export default __webpack_public_path__ + "static/media/world-cup-banner-cn.32bb0b4a.webp";